import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';

const PARTICIPATE_FORM_SETTINGS = {
  showNavigationButtons: true,
  navigationButtonsLocation: 'bottom',
  showEmptyFormSubmit: false,
  formDataSource: 'event_participate_form_data',
};

@Component({
  selector: 'app-duna-user-participate',
  standalone: true,
  imports: [DynamicFormComponent],
  templateUrl: './duna-user-participate.component.html',
  styleUrl: './duna-user-participate.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DunaUserParticipateComponent {
  readonly dynamicInput = {
    bundledSurveyForm: { type: 'text', value: 'event-user-participate-form' },
    formReceiveFunction: { type: 'text', value: 'join_event' },
    surveyJSON: { type: 'surveyJSON', value: '{}' },
    settings: { type: 'json', value: PARTICIPATE_FORM_SETTINGS },
  };
}
